import React, { useCallback } from "react";

import { className as classNames } from "utils/strings";

import FALLBACK from "components/icons/image_icon.svg";

export const Image = ({ className, src, alt, fallback, onFailure }: {
  className?: string;
  src: string | null | undefined;
  alt?: string | null | undefined;
  fallback?: string;
  onFailure?: (url: string) => void;
}): JSX.Element => {
  const onError = useCallback((e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    console.warn(`Error loading image ${e.currentTarget.src} -- showing fallback.`);
    onFailure && onFailure(e.currentTarget.src);
    e.currentTarget.src = FALLBACK;
  }, [onFailure]);

  return (
    <img
      className={classNames({
        [className ?? ""]: true,
      })}
      loading="lazy"
      src={src ?? fallback ?? FALLBACK ?? undefined}
      alt={alt ?? undefined}
      onError={onError}
    />
  );
};
